"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDayChangePermissionValidation = void 0;
var journey_services_1 = require("@athena-portal/journey-services");
var moment = require("moment");
var PaymentDayChangePermissionValidation = /** @class */ (function (_super) {
    __extends(PaymentDayChangePermissionValidation, _super);
    function PaymentDayChangePermissionValidation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentDayChangePermissionValidation.prototype.validateInput = function (input, context) {
        var pageContext = context;
        if (pageContext.engine) {
            var interaction = pageContext.engine.getInteraction();
            if (interaction.paymentDay.currentDay.toString() === interaction.paymentDay.day) {
                var error = this.getErrorMessage(context, "Selected day of the month already is your subscription payment day.");
                return this.invalidResult(error);
            }
            if (interaction.paymentDay.subscriptionStatus === 'MTC') {
                var error = this.getErrorMessage(context, "Your subscription is due to be cancelled soon.");
                return this.invalidResult(error);
            }
            if (!interaction.paymentDay.subscriptionStatus) {
                var error = this.getErrorMessage(context, "No active subscription.");
                return this.invalidResult(error);
            }
            if (interaction.paymentDay.renewalWindowEndDate) {
                var formattedDate = moment.utc(interaction.paymentDay.renewalWindowEndDate).format("D MMMM YYYY");
                var error = this.getErrorMessage(context, "Your current subscription is getting renewed. Please come back on " + formattedDate + ".");
                return this.invalidResult(error);
            }
            if (interaction.paymentDay.currentDate) {
                var restrictionEndDate = moment(interaction.paymentDay.currentDate).add(6, 'M');
                var now = moment();
                if (now.isBefore(restrictionEndDate)) {
                    var formattedRestrictionEndDate = restrictionEndDate.format("D MMMM YYYY");
                    var error = this.getErrorMessage(context, "You're allowed to change payment day once in 6 months. Please come back on " + formattedRestrictionEndDate + ".");
                    return this.invalidResult(error);
                }
            }
        }
        return this.validResult();
    };
    return PaymentDayChangePermissionValidation;
}(journey_services_1.ValidationMethodBase));
exports.PaymentDayChangePermissionValidation = PaymentDayChangePermissionValidation;
//# sourceMappingURL=PaymentDayChangePermissionValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/PaymentDayChangePermissionValidation.js
// module id = 2531
// module chunks = 0